import { IModelInfo } from "../../domain/ModelInfos/IModelInfo";
import { IModelInfoRepository } from "../../domain/ModelInfos/IModelInfoRepository";
import { localDb } from "./LocalDb";

export class ModelInfoRepository implements IModelInfoRepository {
    get(): Promise<IModelInfo[]> {
        return localDb.modelInfo.toArray();
    }
    getById(id: string): Promise<IModelInfo | undefined> {
        return localDb.modelInfo.where("id").equals(id).first();
    }
    async save(items: IModelInfo[]): Promise<void> {
        await localDb.modelInfo.bulkPut(items);
    }
    async delete(id: string): Promise<void> {
        await localDb.modelInfo.delete(id);
    }
    async deleteAll(): Promise<any> {
        await localDb.modelInfo.clear();
    }
}
